import { LoginProviderRoutes } from '@/repository/auth';
const { GetAllAvailable } = LoginProviderRoutes;

export default {
	namespaced : true,
	actions: {
		async index({ }) {
			try {
				return await GetAllAvailable()
			}
			catch (error) {
				console.error('Could not get available login providers.', error);
				throw error;
			}
		}
	}
}